module.exports = __webpack_public_path__ + "media/images/emblems/Jorat-Menthue-coat_of_arms-b549bcec63a648e6896ed3ab3e79e5b3.svg";